/**
 * Money, formatted for the currency it is in.
 *
 * Spend used to be written as `$${n.toFixed(2)}` throughout Stats, which is only right while
 * every ad account bills in dollars. The ad accounts report their currency (Meta's account
 * `currency`, LinkedIn's export `Currency` column), so format with it, defaulting to USD.
 * Formatters are cached: Intl.NumberFormat is not free and Stats formats hundreds of figures.
 */
const cache = new Map<string, Intl.NumberFormat>();

export const formatMoney = (amount: number | null | undefined, currency: string = 'USD'): string => {
  if (amount == null || Number.isNaN(amount)) return '—';
  const code = (currency || 'USD').toUpperCase();
  let fmt = cache.get(code);
  if (!fmt) {
    try {
      fmt = new Intl.NumberFormat('en-US', { style: 'currency', currency: code });
    } catch {
      // An unrecognised code still shows a number rather than throwing
      fmt = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });
    }
    cache.set(code, fmt);
  }
  return fmt.format(amount);
};
